(function () {
  'use strict';

  if (window.ProductProblemsScrollV5Loaded) {
    return;
  }

  window.ProductProblemsScrollV5Loaded = true;

  var scrollStarted = false;
  var resizeFrame;

  function alignHeadings(section) {
    var headings = Array.prototype.slice.call(section.querySelectorAll('[data-problem-heading]'));

    headings.forEach(function (heading) {
      heading.style.minHeight = '';
    });

    if (window.innerWidth < 750 || headings.length < 2) {
      return;
    }

    var tallestHeading = headings.reduce(function (height, heading) {
      return Math.max(height, heading.getBoundingClientRect().height);
    }, 0);

    headings.forEach(function (heading) {
      heading.style.minHeight = Math.ceil(tallestHeading) + 'px';
    });
  }

  function alignAllSections() {
    document.querySelectorAll('[data-product-problems-scroll]').forEach(alignHeadings);
  }

  function revealHeading(heading) {
    heading.removeAttribute('data-pps-awaiting-scroll');
    heading.classList.add('is-sequence-visible');
  }

  function runSequence(section) {
    if (!section || section.hasAttribute('data-pps-sequence-running')) {
      return;
    }

    var headings = Array.prototype.slice.call(section.querySelectorAll('[data-problem-heading]'));
    var nextHeading = headings.find(function (heading) {
      return !heading.hasAttribute('data-pps-complete');
    });

    if (!nextHeading || !nextHeading.hasAttribute('data-pps-in-view')) {
      return;
    }

    section.setAttribute('data-pps-sequence-running', 'true');
    revealHeading(nextHeading);

    var wordCount = nextHeading.querySelectorAll('.pps-word').length;
    var sequenceDuration = 1600 + Math.max(0, wordCount - 1) * 110 + 100;

    window.setTimeout(function () {
      nextHeading.setAttribute('data-pps-complete', 'true');
      section.removeAttribute('data-pps-sequence-running');
      runSequence(section);
    }, sequenceDuration);
  }

  function markHeadingInView(heading) {
    var section = heading.closest('[data-product-problems-scroll]');

    heading.removeAttribute('data-pps-awaiting-scroll');
    heading.setAttribute('data-pps-in-view', 'true');
    runSequence(section);
  }

  function handleFirstScroll() {
    scrollStarted = true;

    document.querySelectorAll('[data-problem-heading][data-pps-awaiting-scroll]').forEach(function (heading) {
      var bounds = heading.getBoundingClientRect();
      var triggerLine = window.innerHeight * 0.88;

      if (bounds.bottom > 0 && bounds.top < triggerLine) {
        markHeadingInView(heading);
      }
    });
  }

  window.addEventListener('scroll', handleFirstScroll, { once: true, passive: true });

  function showAll(section) {
    section.querySelectorAll('[data-problem-heading]').forEach(function (heading) {
      revealHeading(heading);
      heading.setAttribute('data-pps-complete', 'true');
    });
  }

  function initSection(section) {
    if (!section || section.hasAttribute('data-pps-ready')) {
      return;
    }

    section.setAttribute('data-pps-ready', 'true');
    alignHeadings(section);

    if (!section.classList.contains('pps-section--animate')) {
      showAll(section);
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      showAll(section);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        if (!scrollStarted) {
          entry.target.setAttribute('data-pps-awaiting-scroll', 'true');
          return;
        }

        markHeadingInView(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.35,
      rootMargin: '0px 0px -12% 0px'
    });

    section.querySelectorAll('[data-problem-heading]').forEach(function (heading) {
      observer.observe(heading);
    });
  }

  function init(root) {
    if (root.matches && root.matches('[data-product-problems-scroll]')) {
      initSection(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-product-problems-scroll]').forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(alignAllSections);
  }, { passive: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(alignAllSections);
  }
})();
